import styled from "@emotion/styled";
import { ArrowDropDownCircleOutlined } from "@mui/icons-material";
import React, { useState, useEffect } from "react";

import { designSystem } from "@/styles/theme";

export interface Option {
  description: string;
  type: string;
}

interface SelectBoxProps {
  onOpenContrall: (openValue: boolean) => void;
  isOpen: boolean;
  options: Option[] | null; 
  onChange: (selectedValue: Option) => void;
  defaultlabel?: string;
  size?: "default" | "small";
}

const SelectWrapper = styled.div<{ size?: string, open:boolean }>`
  position: relative;
  width: ${(props) => (props.size === "small" ? "70%" : "100%")};

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const OptionsList = styled.ul<{ open: boolean }>`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
  background-color: #fff;
  border: 1px solid ${designSystem.colors.primary};
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  display: ${(props) => (props.open ? "block" : "none")};
  margin-top: ${(props) => (props.open ? "5px" : "0")};
  z-index: 1100;
  max-height: 180px;
  overflow: auto;

  @media (max-width: 768px) {
    max-height: 150px;
  }
`;

const OptionItem = styled.li`
  padding: 8px 10px;
  cursor: pointer;
  &:hover {
    background-color: #f0f0f0;
  }
`;

const SelectBox = ({ isOpen,options, onChange, defaultlabel = "Select an option", size, onOpenContrall }: SelectBoxProps) => {
  const [isSelectedOpen, setIsSelectedOpen] = useState(false);

  const handleOptionSelect = (option: Option) => {
    onOpenContrall(false)
    onChange(option);
  };

  return (
    <SelectWrapper size={size} open={isOpen}>
      <OptionsList open={isOpen}>
        {options?.map((option, index) => (
          <OptionItem key={index} onClick={() => handleOptionSelect(option)}>
            {option.description}
          </OptionItem>
        ))}
      </OptionsList>
    </SelectWrapper>
  );
};

export default SelectBox;
